module.exports = __webpack_public_path__ + "media/images/app-download-screen-bc25bc1aeea210727e36c50383e18293.png";